export const iconFontAwesomeMoneyManatSign = (
	<i className="fa-solid fa-manat-sign"></i>
);
